<script lang="ts" setup>
import { computed } from 'vue'

import { useAd } from '../../../advertisement/composables/use-ad'

const props = defineProps<{
  nativeTeaserIndex: number
}>()

const nativeTeaserIndex = computed(() => props.nativeTeaserIndex)
const { slotName, status, minWidth, minHeight } = useAd('native', nativeTeaserIndex.value)
</script>

<template>
  <div class="sm:basis-1/4"
       :style="{ minWidth: minWidth ?? undefined, minHeight: minHeight ?? undefined }">
    <div v-if="slotName && status !== 'failed'"
         :id="slotName"
         class="gujAd teaser h-full [&&&]:text-left !flex" />
    <slot v-if="status !== 'successful'" />
  </div>
</template>

<style>
/* quick fix until AdA updated the markup
 * ToDo: remove this when AdA is updated
*/
.gujAd.teaser > .emsTeaserContainer > a {
  height: 100%;
}
</style>
